import React from "react";
import { Route, Routes } from "react-router";
import CBSA from "../UtilityData/CBSA";
import MEDCInflation from "./MEDCInflation";
import MEDCByGender from "./MEDCByGender";
import LSRAF from "./LSRAF";
import DRF from "./DRF";
import GEO from "./GEO";
import InsuranceCarrier from "./InsuranceCarrier";
import FundingArrangement from "./FundingArrangement";
import COCI from "./COCI";
import Tier from "./Tier";
import CbsaSizePlan from "./CbsaSizePlan";
import IndustryRisk from "./IndustryRisk";
import PlanVar from "./PlanVar";
import LargeClaim from "./LargeClaim";
import Wellness from "./Wellness";
import Maternity from "./Maternity";
import ERUs from "./ERUs";
import ConditionCategory from "./ConditionCategory";
import RUBs from "./RUBs";
import UWMargin from "./Margin";
import UWellness from "./UWellness";
import GDORMasterDetail from "./GDORMasterDetail";
import AgeSexRisk from "./AgeSexRisk";
import SalaryRisk from "./SalaryRisk";
import InvalidICDZipcode from "./InvalidICDZipcode";
import TrackImportHistory from "./TrackImportHistory"
import RankedMeasureData from "./RankedMeasureData";
import AgeBandRub from "./AgeBandRub";

const UtilityData = ({ navigate }) => {
  return (
    <Routes>
      <Route index element={<CBSA navigate={navigate} />} />
      <Route path="/cbsa" element={<CBSA navigate={navigate} />} />
      <Route path="/medci" element={<MEDCInflation navigate={navigate} />} />
      <Route path="/medcg" element={<MEDCByGender navigate={navigate} />} />
      <Route path="/lsraf" element={<LSRAF navigate={navigate} />} />
      <Route path="/drf" element={<DRF navigate={navigate} />} />
      <Route path="/geo" element={<GEO navigate={navigate} />} />
      <Route path="/coci" element={<COCI navigate={navigate} />} />
      <Route path="/indrisk" element={<IndustryRisk navigate={navigate} />} />
      <Route path="/insur" element={<InsuranceCarrier navigate={navigate} />} />
      <Route
        path="/funding"
        element={<FundingArrangement navigate={navigate} />}
      />

      <Route path="/tier" element={<Tier navigate={navigate} />} />

      <Route
        path="/cbsasizeplan"
        element={<CbsaSizePlan navigate={navigate} />}
      />

      <Route path="/planvar" element={<PlanVar navigate={navigate} />} />

      <Route
        path="/funding"
        element={<FundingArrangement navigate={navigate} />}
      />
      <Route path="/maternity" element={<Maternity navigate={navigate} />} />

      <Route path="/largeclaim" element={<LargeClaim navigate={navigate} />} />

      <Route path="/wellness" element={<Wellness navigate={navigate} />} />
      <Route
        path="/topconditions"
        element={<ConditionCategory navigate={navigate} />}
      />

      <Route path="/rubs" element={<RUBs navigate={navigate} />} />
      <Route path="/uwmargin" element={<UWMargin navigate={navigate} />} />
      <Route path="/uwellness" element={<UWellness navigate={navigate} />} />
      <Route path="/gdormasterdetail" element={<GDORMasterDetail navigate={navigate} />} />
      <Route path="/uwellness" element={<UWellness navigate={navigate} />} />
      <Route path="/agesexrisk" element={<AgeSexRisk navigate={navigate} />} />
      <Route path="/salaryrisk" element={<SalaryRisk navigate={navigate} />} />

      <Route path="/icd10zip" element={<InvalidICDZipcode navigate={navigate} />} />
      <Route path="/trackhistory" element={<TrackImportHistory navigate={navigate} />} />
      <Route path="/rankedmeasuredata" element={<RankedMeasureData navigate={navigate} />} />
      <Route path="/ageband" element={<AgeBandRub navigate={navigate} />} />
      <Route path="/eru" element={<ERUs navigate={navigate} />} />

      {/* <Route path="UtilityData" element={<UtilityData navigate={navigate} />} />
      <Route
        path="importcensus"
        element={<ImportCensus navigate={navigate} />}
      />
      <Route
        path="report&export"
        element={<ReportExport navigate={navigate} />}
      /> */}
    </Routes>
  );
};

export default UtilityData;
